@if (featuresFormGroup) {
    <div class="mb-3">
        <div class="d-flex align-items-center gap-2 mb-3">
            <mat-slide-toggle [formControl]="showFacilityInformationControl">
                Add facility information
            </mat-slide-toggle>
        </div>

        @if (showFacilityInformationControl.value) {
            @if (facilitiesArray.length) {
                @for (f of facilitiesArray.controls; let fi = $index; track fi) {
                    <div class="card mb-3 p-3">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <h5>Facility {{ fi + 1 }}</h5>
                            <div>
                                <button mat-button color="warn" type="button" (click)="removeFacility(fi)">
                                    Remove
                                </button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Airport Name</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.airportName" />
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Airport Code</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.airportCode" />
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Address 1</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.address1" />
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Address 2</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.address2" />
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Phone</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.phone" />
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Firms Code</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.firmsCode" />
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>City</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.city" />
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>State</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.state" />
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>ZIP</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.zip" />
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Country</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.country" />
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Open Time</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.openTime" />
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Close Time</mat-label>
                                    <input matInput [formControl]="getFacilityGroup(fi).controls.closeTime" />
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Position Lat</mat-label>
                                    <input matInput [formControl]="getPositionGroupFor(fi).controls.lat" />
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Position Lng</mat-label>
                                    <input matInput [formControl]="getPositionGroupFor(fi).controls.lng" />
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <label class="mat-label">Email</label>
                                @for (e of getFacilityGroup(fi).controls.email.controls; let ei = $index; track ei) {
                                    <div class="d-flex gap-2 align-items-center mb-2">
                                        <mat-form-field appearance="outline" class="flex-grow-1">
                                            <input
                                                matInput
                                                [formControl]="getFacilityGroup(fi).controls.email.controls[ei]"
                                            />
                                        </mat-form-field>
                                        <button
                                            mat-icon-button
                                            color="warn"
                                            type="button"
                                            (click)="removeArrayItemFor(fi, 'email', ei)"
                                        >
                                            <mat-icon>remove</mat-icon>
                                        </button>
                                    </div>
                                }
                                <button mat-button type="button" (click)="addEmailFor(fi)">Add Email</button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <label class="mat-label">AWB Prefixes</label>
                                @for (
                                    p of getFacilityGroup(fi).controls.awbPrefixes.controls;
                                    let pi = $index;
                                    track pi
                                ) {
                                    <div class="d-flex gap-2 align-items-center mb-2">
                                        <mat-form-field appearance="outline" class="flex-grow-1">
                                            <input
                                                matInput
                                                [formControl]="getFacilityGroup(fi).controls.awbPrefixes.controls[pi]"
                                            />
                                        </mat-form-field>
                                        <button
                                            mat-icon-button
                                            color="warn"
                                            type="button"
                                            (click)="removeArrayItemFor(fi, 'awbPrefixes', pi)"
                                        >
                                            <mat-icon>remove</mat-icon>
                                        </button>
                                    </div>
                                }
                                <button mat-button type="button" (click)="addAwbPrefixFor(fi)">Add AWB Prefix</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <label class="mat-label">Customers</label>
                                @for (
                                    c of getFacilityGroup(fi).controls.customers.controls;
                                    let ci = $index;
                                    track ci
                                ) {
                                    <div class="d-flex gap-2 align-items-center mb-2">
                                        <mat-form-field appearance="outline" class="flex-grow-1">
                                            <input
                                                matInput
                                                [formControl]="getFacilityGroup(fi).controls.customers.controls[ci]"
                                            />
                                        </mat-form-field>
                                        <button
                                            mat-icon-button
                                            color="warn"
                                            type="button"
                                            (click)="removeArrayItemFor(fi, 'customers', ci)"
                                        >
                                            <mat-icon>remove</mat-icon>
                                        </button>
                                    </div>
                                }
                                <button mat-button type="button" (click)="addCustomerFor(fi)">Add Customer</button>
                            </div>
                        </div>
                        <div class="mb-2">
                            <h5>Operating Hours</h5>
                            @for (oh of getOperatingHoursArrayFor(fi).controls; let oidx = $index; track oidx) {
                                <div class="d-flex gap-2 align-items-center mb-2">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Days</mat-label>
                                        <input
                                            matInput
                                            [formControl]="getOperatingHoursArrayFor(fi).controls[oidx].controls.days"
                                        />
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Hour</mat-label>
                                        <input
                                            matInput
                                            [formControl]="getOperatingHoursArrayFor(fi).controls[oidx].controls.hour"
                                        />
                                    </mat-form-field>
                                    <button
                                        mat-icon-button
                                        color="warn"
                                        type="button"
                                        (click)="removeOperatingHourFor(fi, oidx)"
                                    >
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                </div>
                            }
                            <button mat-button type="button" (click)="addOperatingHourFor(fi)">
                                Add Operating Hour
                            </button>
                        </div>
                    </div>
                }
            }
            <div class="d-flex justify-content-end">
                <button mat-button type="button" (click)="addFacility()">Add Facility</button>
            </div>
        }
    </div>
}
